var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSendButton(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1422",
    "data-name": "Group 1422",
    transform: "translate(-704 -976)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_118",
    "data-name": "Ellipse 118",
    cx: 22.5,
    cy: 22.5,
    r: 22.5,
    transform: "translate(704 976)",
    fill: "#07b4e8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "noun-send-4218826",
    d: "M40.748,21.214a.731.731,0,0,0-.786-.164L19.464,29.1a.732.732,0,0,0-.014,1.357l5.22,2.175L23.414,37.66a.732.732,0,0,0,.71.909.74.74,0,0,0,.178-.022l5.024-1.256,2.175,5.22a.732.732,0,0,0,.676.45h.007a.731.731,0,0,0,.674-.465L40.911,22A.731.731,0,0,0,40.748,21.214ZM28.517,35.641l-2.2-2.2L37.3,24.66Z",
    transform: "translate(696.037 967.002)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendButton);
export default __webpack_public_path__ + "static/media/sendButton.032dc22da155d8c848c4138c157487b4.svg";
export { ForwardRef as ReactComponent };